export const tokens = {
    section: {
        gap: 16,
        titleSize: 18,
    },
    clearAction: {
        padding: 4,
        radius: 4,
        fontSize: 12,
    },
    summary: {
        gap: 10,
        titleSize: 16,
        priceSize: 18,
    },
};
